import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import AttendanceBoard from "@/components/attendance/AttendanceBoard";

export default function AdminAttendance() {
    const [programs, setPrograms] = useState([]);
    const [params] = useSearchParams();
    const initialProgramId = params.get("program_id");

    useEffect(() => {
        api.get("/programs", { params: { include_archived: true } })
            .then((r) => {
                // Only active (non-deleted) programs
                const list = (r.data || [])
                    .filter((p) => !p.is_deleted)
                    .sort((a, b) => a.title.localeCompare(b.title));
                setPrograms(list);
            })
            .catch(() => setPrograms([]));
    }, []);

    return (
        <div className="max-w-7xl mx-auto p-6" data-testid="admin-attendance-page">
            <AttendanceBoard
                programs={programs}
                initialProgramId={initialProgramId}
                heading="Student attendance"
                subheading="Track who's studying which program, and how long. Exports as Excel for registrar records."
            />
        </div>
    );
}
